export default __webpack_public_path__ + "static/media/nanga.c84839a9.jpg";